import React, { useState } from "react";
import styles from "./ProgramLevelMovement.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";
import { FaPlusCircle } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

const ProgramLevelMovement = () => {
  const dispatch = useDispatch();

  const [currentProgram, setCurrentProgram] = useState("");
  const [ruleType, setRuleType] = useState("");
  const [moveOption1, setMoveOption1] = useState(false);
  const [moveOption2, setMoveOption2] = useState(false);

  const handleCancel = () => {
    setCurrentProgram("");
    setRuleType("");
    setMoveOption1(false);
    setMoveOption2(false);

  };

  const handleSubmit = () => {
    if (!currentProgram || !ruleType) {
      alert(
        "Please fill all mandatory (*) fields including at least one checkbox."
      );
      return;
    }

    const payload = {
      currentProgram,
      ruleType,
      moveOption1,
      moveOption2,
    };
    console.log("✔ Submitted Program Level Movement:", payload);
    dispatch(closeModal());
  };

  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardHeader}>
        <HeadingAndIcon icon={<FaPlusCircle />} heading="Add New Rule" />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>

      <div className={styles.cardBody}>
        <HeadingAndDropDown
          label="When leaving Current Program"
          name="currentProgram"
          value={currentProgram}
          onChange={(e) => setCurrentProgram(e.target.value)}
          required
          placeholder="Enter template name"
          options={[
            { label: "Program A", value: "programA" },
            { label: "Program B", value: "programB" },
          ]}
        />

        <label className={styles.inputLabel}>A Student Will :</label>
        <div className={styles.checkboxGroup}>
          <label
            className={`${styles.checkLabel} ${
              moveOption1 ? styles.active : ""
            }`}
          >
            <input
              type="checkbox"
              checked={moveOption1}
              onChange={(e) => {
                setMoveOption1(e.target.checked);
                console.log("Checkbox 1 clicked");
              }}
            />
            Move to Next Program
          </label>

          <label
            className={`${styles.checkLabel} ${
              moveOption2 ? styles.active : ""
            }`}
          >
            <input
              type="checkbox"
              checked={moveOption2}
              onChange={(e) => {
                setMoveOption2(e.target.checked);
                console.log("Checkbox 2 clicked");
              }}
            />
            Move to Next Program
          </label>
        </div>

        <HeadingAndDropDown
          label="Movement Rule"
          name="ruleType"
          value={ruleType}
          onChange={(e) => setRuleType(e.target.value)}
          required
          placeholder="Select movement rule"
          options={[
            { label: "Based on Age", value: "age" },
            { label: "Based on Date", value: "date" },
          ]}
        />

        <div className={styles.footerActions}>
          <SaveAndCancel onSave={handleSubmit} onCancel={handleCancel} saveLabel="Submit" />
        </div>
      </div>
    </div>
  );
};

export default ProgramLevelMovement;
